module.exports = __webpack_public_path__ + "static/img/12.3138859.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/12.png
// module id = h3d8
// module chunks = 0